module.exports = __webpack_public_path__ + "static/media/Reservas.d13170dd.PNG";